import { render } from "./AboutUs.vue?vue&type=template&id=18716a80&scoped=true"
import script from "./AboutUs.vue?vue&type=script&lang=js"
export * from "./AboutUs.vue?vue&type=script&lang=js"

import "./AboutUs.vue?vue&type=style&index=0&id=18716a80&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-18716a80"

export default script